import { FiCheck } from "react-icons/fi";
import { BrandPanel } from "./AuthLayout";
import { AUTH_FEATURES, AUTH_PANEL_IMAGE } from "./ImageComponent";

export const SuccessImageComponent = ({ point }: any) => {
  return (
    <BrandPanel
      showOnMobile
      tone="success"
      statusIcon={FiCheck}
      eyebrow="Survey complete"
      title="Congratulations!"
      description={`You've completed the survey and earned ${point} Points.`}
      features={AUTH_FEATURES}
      image={AUTH_PANEL_IMAGE}
      imageAlt="People taking part in surveys"
    />
  );
};
